import { api } from '../services/api.js';

export async function fetchPdfAsObjectUrl(endpoint: string): Promise<string> {
  const res = await api.get(endpoint, { responseType: 'blob' });
  const blob = new Blob([res.data], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
}

export async function downloadPdf(endpoint: string, filename: string): Promise<void> {
  const url = await fetchPdfAsObjectUrl(endpoint);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** iOS Safari (and many mobile browsers) cannot display blob: PDFs inside iframes. */
export function isMobilePdfPreviewUnreliable(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/i.test(ua);
  const narrow = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
  return isIOS || isAndroid || narrow;
}

/** Open an existing blob object URL in a new tab (works on iOS where iframe fails). */
export function openPdfObjectUrl(url: string): void {
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  a.rel = 'noopener noreferrer';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export function extractApiError(err: unknown): {
  code?: string;
  message: string;
  details?: unknown;
} {
  const e = err as {
    response?: {
      data?: {
        error?: { code?: string; message?: string; details?: unknown } | string;
        details?: unknown;
      };
    };
    message?: string;
  };
  const data = e?.response?.data?.error;
  if (typeof data === 'string') {
    return { message: data, details: e?.response?.data?.details };
  }
  if (data && typeof data === 'object') {
    return {
      code: data.code,
      message: data.message || 'Request failed',
      details: data.details ?? e?.response?.data?.details,
    };
  }
  return { message: e?.message || 'Request failed' };
}
